export enum SCHEDULE_TYPE {
  NOW = 'NOW',
  FUTURE = 'FUTURE',
  RECURRING = 'RECURRING'
}

export enum SCHEDULE_FREQUENCY {
  ONE_TIME = 'ONE_TIME',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
